import { render, staticRenderFns } from "./ReservationsCongratulationsFinal127.vue?vue&type=template&id=397fd3bc"
import script from "./ReservationsCongratulationsFinal127.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationsCongratulationsFinal127.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports